module.exports = __webpack_public_path__ + "assets/img/23-m.4b4eda2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/23-m.jpg
// module id = MJW0
// module chunks = 0